export default __webpack_public_path__ + "static/media/AbuDhabiDeclaration.8becf6bd.pdf";